import { Typography } from "@material-ui/core";
import { IconSwitch } from "./IconSwitch";
import { useTranslation } from "react-i18next";
import "./iconLabelSwitchStyle.scss";
/**
 * @author IKlapouch
 * 07/02/2021
 */

export const IconLabelSwitch = ({ name, isHeader, labelName, headerAlign, size, customLabel, fontSize, color, style, variant }) => {
    const { t } = useTranslation()

    const divStyle = {
        display: isHeader ? 'flex' : null,
        justifyContent: isHeader
            ? headerAlign ? headerAlign : 'center'
            : null,

    }

    const labelStyle = {
        fontWeight: isHeader ? "bold" : null,
        fontSize: isHeader ? "0.875rem" : null,
        marginLeft: "0.5em",
    };

    return (
        <>
            <div style={divStyle}>
                <Typography variant={variant} style={style ? style : null} className={"typographyStyle"}>
                    <IconSwitch fontSize={fontSize} name={name} isHeader={isHeader} size={size} color={color} />
                    <div style={labelStyle}>{customLabel ? customLabel : labelName ? t(labelName) : t(name)}</div>
                </Typography>
            </div>
        </>
    );
};
